import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { Button, CheckCircleIcon, H1 } from '../../components/';
import { closeModal } from '../../components/modal/actions';
import { TranslatedCopy } from '../../intl/TranslatedCopy';

import { userTypes } from '../../types/user';

export const ImportAccountSuccess = ({ closeModal, userValidation, resetUserValidation, user }) => {
  const handleImportClick = () => {
    resetUserValidation();
  };
  const handleDoneClick = () => {
    resetUserValidation();
    closeModal();
  };
  return (
    <div className='ta-sm-c'>
      <H1 className='mt2-sm prl5-sm mb7-sm'>
        <TranslatedCopy id='profile.import.success.title' />
      </H1>
      <div className='pb7-sm'>
        <div className='body-4 text-color-secondary'>
          <TranslatedCopy id='profile.import.success.login.title' />
        </div>
        <div>{user && user.username}</div>
      </div>
      <div className='body-4 text-color-secondary pb7-sm'>
        <TranslatedCopy id='profile.import.success.imported.title' />
      </div>
      <CheckCircleIcon className='large headline-3 p2-sm prl3-sm' />
      <div className='headline-4 mt3-sm mb1-sm'>{userValidation && userValidation.accountName}</div>
      <div className='mb7-sm'>{userValidation && userValidation.username}</div>
      <div className='body-4 text-color-secondary mb9-sm'>
        <TranslatedCopy id='profile.import.success.copy' />
      </div>
      <Button
        extraClassName='text-color-secondary body-4 mb10-sm u-full-width'
        textLink
        matchCase
        onClick={handleImportClick}
      >
        <TranslatedCopy id='profile.import.title' />
      </Button>
      <Button extraClassName='u-full-width' data-desc='importLegacyAccount__form_submit' onClick={handleDoneClick}>
        <TranslatedCopy id='global.done' />
      </Button>
    </div>
  );
};

ImportAccountSuccess.defaultProps = {
  user: null,
  userValidation: null
};

ImportAccountSuccess.propTypes = {
  user: userTypes,
  userValidation: PropTypes.any,
  resetUserValidation: PropTypes.func.isRequired,
  closeModal: PropTypes.func.isRequired
};

const connector = connect(() => ({}), {
  closeModal
});

export default connector(ImportAccountSuccess);
